import controller from './titleBar.controller';
import template from './titleBar.html';
import './titleBar.scss';
/**
 * @ngdoc component
 * @name titleBar
 * @description
 * The title bar component of the app.
 *
 * @memberof rootModule
 */
export default {
  /**
   * The controller class for the component.
   * @type {TitleBarController}
   */
  controller,
  /**
   * The HTML template for the component.
   * @type {String}
   */
  template,
  /**
   * Component bindings
   * @type {Object}
   * @property {Object} item The menu item to be shown.
   */
  bindings: {
    item: '<',
  },
};



// WEBPACK FOOTER //
// ./src/frontend/modules/root/components/titleBar/titleBar.component.js